<template>
  <v-row
    no-gutters
    class="mb-4"
  >
    <v-col
      cols="3"
      class="text-size-12 font-weight-medium d-flex align-center"
      style="color: var(--v-synthesis-ui-grey-01-base);"
    >
      <span class="mr-4">{{ amount }}</span>
    </v-col>
    <v-col
      cols="9"
      class="text-size-12 font-weight-medium d-flex align-center"
      style="color: var(--v-synthesis-ui-grey-01-base);"
    >
      <div
        class="mr-2"
        :style="{
          width: '10px',
          height: '10px',
          borderRadius: '50%',
          backgroundColor: `var(${$t(`RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.${financialInstrumentKey}.Color`)})`
        }"
      />
      {{ $t(`RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.${financialInstrumentKey}.Title`) }}
    </v-col>
  </v-row>
</template>

<script>
import { toNumberFormatNotationShort } from '@/lib/utils/helper'
import riskBaseCurrency from '@/theme/default/views/risks/mixins/riskBaseCurrency'
export default {
  name     : 'FinancialInstrumentLabel',
  mixins   : [riskBaseCurrency],
  dataStore: {
    BankReadiness       : 'RiskLiquidity.BankReadiness.Data',
    riskBaseCurrencyData: 'Risks.BaseCurrency.Data'
  },
  props: {
    circleColor: {
      type   : String,
      default: '#000000'
    },
    financialInstrumentKey: {
      type   : String,
      default: ''
    }
  },
  computed: {
    id () {
      return this.user?.selectedAccountId || null
    },
    amount () {
      if (!this.BankReadiness || !this.BankReadiness.startItem || !this.financialInstrumentKey) {
        return `${this.riskBaseCurrencyDisplayName}0`
      }
      return `${this.riskBaseCurrencyDisplayName}${toNumberFormatNotationShort(this.BankReadiness.startItem[this.financialInstrumentKey])}`
    }
  }
}
</script>
